export enum EditMode {
  NONE = "",
  EXIT = "exit",
  UPDATE = "update",
  DELETE = "delete",
}
